module.exports = __webpack_public_path__ + "static/img/logo-1.2a9fa3ec.png";